import { useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SimpleCheckbox(_ref) {
  var value = _ref.value,
      label = _ref.label,
      name = _ref.name,
      checked = _ref.checked,
      className = _ref.className,
      onChange = _ref.onChange,
      defaultChecked = _ref.defaultChecked,
      disabled = _ref.disabled;

  var _useState = useState(checked || defaultChecked),
      isChecked = _useState[0],
      setIsChecked = _useState[1];

  useEffect(function () {
    setIsChecked(checked || defaultChecked);
  }, [checked, defaultChecked]);

  function handleChange(e) {
    if (onChange) onChange(e);
    var target = e.target;
    setIsChecked(target.checked);
  }

  var id = value + name;
  return /*#__PURE__*/_jsx("label", {
    htmlFor: id,
    className: "cursor-pointer select-none",
    children: /*#__PURE__*/_jsxs("div", {
      className: "checkbox relative flex items-center ".concat(className),
      role: "checkbox",
      "aria-disabled": disabled,
      "aria-checked": typeof checked === 'boolean' ? checked : isChecked,
      children: [/*#__PURE__*/_jsx("div", {
        className: "box flex-shrink-0 cursor-pointer border border-black/20",
        children: (typeof checked === 'boolean' ? checked : isChecked) && /*#__PURE__*/_jsx("div", {
          className: "check-mark bg-brand-secondary h-full w-full"
        })
      }), /*#__PURE__*/_jsx("input", {
        id: id,
        type: "checkbox",
        name: name,
        value: value,
        onChange: handleChange,
        checked: isChecked,
        className: "absolute bottom-0 left-0 right-0 top-0 cursor-pointer opacity-0",
        disabled: disabled
      }), /*#__PURE__*/_jsx("p", {
        className: "p-small ml-2 ",
        children: label
      })]
    })
  });
}